<common-top-tool-bar [title]="'英语王者级别'" [actionsTemplate]="actionsTpl">
  <ng-template #actionsTpl>
    <button nz-button nzType="primary" nzSize="large" routerLink="/admin/v3/game/levels/add">
      <i nz-icon nzType="plus" nzTheme="outline"></i>
      新增级别
    </button>
  </ng-template>
</common-top-tool-bar>

<div class="page-main game-level-index">
  <div class="page-main-table">
    <nz-table
      class="data-table"
      #levelTable
      [nzData]="rows"
      [nzLoading]="loading"
      nzTableLayout="fixed"
      [nzFrontPagination]="true"
      [nzShowPagination]="false"
      [nzScroll]="{ x: '1380px' }"
    >
      <thead>
        <tr>
          <th nzWidth="64px">序号</th>
          <th nzWidth="120px">级别 code</th>
          <th nzWidth="140px">级别名称</th>
          <th nzWidth="100px">题库数量</th>
          <th nzWidth="100px">每日次数上限</th>
          <th nzWidth="120px">级别状态</th>
          <th nzWidth="100px">创建人</th>
          <th nzWidth="168px">创建时间</th>
          <th nzRight nzWidth="160px">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of levelTable.data; let i = index; trackBy: trackById">
          <td>{{ rowIndex(i) }}</td>
          <td>{{ row.levelCode }}</td>
          <td nzEllipsis nz-tooltip [nzTooltipTitle]="row.name">{{ row.name }}</td>
          <td>{{ row.resourceCount }}</td>
          <td>{{ row.dailyLimit ?? 0 }}</td>
          <td>
            <nz-switch
              [ngModel]="row.status === GameLevelStatus.ACTIVE"
              (ngModelChange)="onStatusSwitch(row, $event)"
              nzCheckedChildren="有效"
              nzUnCheckedChildren="无效"
            ></nz-switch>
          </td>
          <td>{{ formatCreatedBy(row.createdBy) }}</td>
          <td>{{ row.createdAt | date: 'yyyy-MM-dd HH:mm' }}</td>
          <td nzRight>
            <a nz-button nzType="link" nzSize="small" (click)="goEdit(row)">编辑</a>
            <nz-divider nzType="vertical"></nz-divider>
            <a
              nz-button
              nzType="link"
              nzDanger
              nzSize="small"
              nz-popconfirm
              nzPopconfirmTitle="确定删除该级别？"
              (nzOnConfirm)="deleteRow(row)"
            >删除</a>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
